export default __webpack_public_path__ + "static/thanksForWatching-e61062b7a8ec1cf09431367ff14318c3.png";